<template>
  <div class="left-sidebar">
    <div class="left-menu" :style="menuContainerStyle">
      <div 
        class="left-menu-item" 
        v-for="(item, index) in leftMenuItems" 
        :key="index"
        @mouseenter="onMenuEnter(index)" 
        @mouseleave="onMenuLeave()"
        :style="menuItemStyle"
      >
        <a @click="handleMenuClick(item)" class="menu-link" href="javascript:void(0)">
          <img 
            :src="hoveredIndex === index ? item.hoverIcon : item.icon" 
            :alt="item.name" 
            class="menu-icon"
            :style="menuIconStyle"
          />
          <span class="menu-text">{{ item.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftSidebar',
  props: {
    leftMenuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    hoveredIndex: {
      type: Number,
      default: null
    },
    user: {
      type: [Object, Array],
      default: () => null
    }
  },
  data() {
    return {
      publicRoutes: ['/main?type=popular', '/main?type=casino', '/main?type=slot', '/main?type=fishing'],
      headerHeight: 60,
      verticalPadding: 40, // .left-menu padding-top + padding-bottom
      itemGap: 16,
      itemSize: 110,
      iconSize: 96
    }
  },
  computed: {
    menuItemStyle() {
      return {
        width: '100%',
        height: this.itemSize + 'px'
      }
    },
    menuIconStyle() {
      return {
        width: this.iconSize + 'px',
        height: this.iconSize + 'px'
      }
    },
    menuContainerStyle() {
      return {
        rowGap: this.itemGap + 'px'
      }
    }
  },
  methods: {
    onMenuEnter(index) {
      this.$emit('menu-enter', index)
    },
    onMenuLeave() {
      this.$emit('menu-leave')
    },
    updateSizes() {
      const count = Array.isArray(this.leftMenuItems) ? this.leftMenuItems.length : 0
      if (count <= 0) return

      // Available vertical space equals viewport height minus header and container paddings
      const containerHeight = window.innerHeight - this.headerHeight
      const available = containerHeight - this.verticalPadding - (count - 1) * this.itemGap

      // Size each menu item to fit within the available height
      let size = Math.floor(available / count)
      // Clamp only the maximum to avoid overflow when many items
      const maxSize = 160
      size = Math.max(0, Math.min(maxSize, size))

      // Icon slightly smaller than the item box and fit content width
      let icon = Math.floor(size * 0.82)
      const menu = this.$el && this.$el.querySelector ? this.$el.querySelector('.left-menu') : null
      let contentWidthCap = 100
      if (menu) {
        const styles = window.getComputedStyle(menu)
        const paddingH = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight)
        contentWidthCap = Math.max(0, menu.clientWidth - paddingH)
      }
      icon = Math.min(icon, Math.max(0, Math.floor(contentWidthCap)))

      this.itemSize = size
      this.iconSize = icon
    },
    handleMenuClick(item) {
      // Special handling for /playsport - open in new tab
      if (item.path === '/playsport' || item.path === '/playesport') {
        window.open(item.path, '_blank')
        return
      }

      const isPublic = this.publicRoutes.includes(item.path)
      const isLoggedIn = this.user && (Array.isArray(this.user) ? this.user.length > 0 && this.user[0].key : this.user.key)
      
      if (!isPublic && !isLoggedIn) {
        // Show login modal for protected routes when not logged in
        const loginModal = document.getElementById('loginModal')
        if (loginModal) {
          const modal = new bootstrap.Modal(loginModal)
          modal.show()
        } else {
          // Fallback: try jQuery if bootstrap is not available
          if (window.$ && window.$('#loginModal').length) {
            window.$('#loginModal').modal('show')
          } else {
            // Final fallback: trigger modal via data attributes
            const modalTrigger = document.querySelector('[data-target="#loginModal"]')
            if (modalTrigger) {
              modalTrigger.click()
            }
          }
        }
      } else {
        // Navigate to route (either public route or user is logged in)
        this.$router.push(item.path)
      }
    }
  },
  watch: {
    leftMenuItems: {
      handler() {
        this.$nextTick(() => this.updateSizes())
      },
      deep: true
    }
  },
  mounted() {
    this.updateSizes()
    window.addEventListener('resize', this.updateSizes)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSizes)
  }
}
</script>

<style scoped>
.left-sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100px;
  height: calc(100vh - 60px);
  background: linear-gradient(180deg, #1a1a1a 0%, #333333 100%);
  border-right: 2px solid #DF4818;
  z-index: 1000;
  overflow: hidden;
}

.left-menu {
  padding: 20px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-start;
}

.left-menu-item {
  /* sizing handled by inline styles to fit 100% height */
  margin-bottom: 0;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.left-menu-item:hover {
  transform: translateY(-2px);
}

.menu-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease;
}

.menu-link:hover {
  color: #000000;
  text-decoration: none;
  cursor: pointer;
}

.menu-icon {
  display: block;
  margin: 0 auto;
  object-fit: contain;
}

.menu-text {
  display: none;
}
/* @media (max-width: 768px) {
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }

  .menu-text {
    font-size: 10px;
  }

  .menu-icon {
    width: 60px;
    height: 60px;
  }
} */
</style>
